import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import '../styles/ForgotPassword.css';

export default function VerifyEmail({ onLoginSuccess }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('Verifying your email...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Verification link is missing or invalid.');
      return;
    }

    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      try {
        const result = await authService.verifyEmail(token);
        if (result.success) {
          window.history.replaceState({}, document.title, '/verify-email');
          setStatus('Email verified. Signing you in...');
          if (onLoginSuccess) {
            await onLoginSuccess(result.user);
          } else {
            navigate('/my-programs', { replace: true });
          }
        } else {
          setError(result.message || 'Email verification failed');
        }
      } catch (err) {
        setError(err.response?.data?.message || err.message || 'Email verification failed');
      }
    };

    run();
  }, [searchParams, navigate, onLoginSuccess]);

  if (error) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <h2>Verification failed</h2>
          <p className="forgot-password-subtitle">{error}</p>
          <button className="forgot-password-bttn" onClick={() => navigate('/')}>
            Go home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <h2>{status}</h2>
        <p className="forgot-password-subtitle">Please wait a moment.</p>
      </div>
    </div>
  );
}
